// Arquivo: src/components/ValidationStep.js
// Local: /src/components/ValidationStep.js
// 
// CORRIGIDO: Agora mostra valores reais e mínimos esperados

import React, { useState, useRef, useEffect } from 'react';
import ValidationResult from './ValidationResult';
import { CameraIcon, BigCameraIcon, RefreshIcon } from './Icons';
// import {
//   validateDeviceIntegrity,
//   validateCamera,
//   validateLighting,
//   validateNetwork
// } from '../../utils/validators';
import { VALIDATION_PARAMS } from '../../constants/validation/validationParams';
import '../../styles/device-validation/ValidationStep.css';
import GVButton from '../gov-br/button';
import { validateCamera, validateDeviceIntegrity, validateLighting, validateNetwork } from '../../utils/validators/validators';
import { Mexx2DOConsole } from '../../utils/mexxTalkConsole';


const ValidationStep = ({ onSuccess, onRetry, onResults, isRetrying }) => {
  const [validationResults, setValidationResults] = useState({
    camera: null,
    lighting: null,
    network: null,
    device: null
  });
  const [isValidating, setIsValidating] = useState(false);
  const [showRetry, setShowRetry] = useState(false);
  const [showAdvanceButton, setShowAdvanceButton] = useState(false);
  const [stream, setStream] = useState(null);
  const [currentStep, setCurrentStep] = useState('');
  const canvasRef = useRef(null);
  const videoRef = useRef(null);

  const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  // Função para limpar o stream
  const cleanupStream = () => {
    if (stream) {
      stream.getTracks().forEach(track => {
        track.stop();
      });
      setStream(null);
    }
    if (videoRef && videoRef.current) {
      const currentStream = videoRef.current.srcObject;
      if (currentStream) {
        currentStream.getTracks().forEach(track => track.stop());
      }
      videoRef.current.srcObject = null;
    }
  };

  // const cleanupStream = () => {
  //   if (stream) {
  //     stream.getTracks().forEach(track => {
  //       track.stop();
  //     });
  //     setStream(null);
  //   }
  //   if (videoRef.current) {
  //     videoRef.current.srcObject = null;
  //   }
  // };

  // Limpa stream ao desmontar componente
  useEffect(() => {
    return () => {
      cleanupStream();
      
    };
  }, []);

  useEffect(() => {
    Mexx2DOConsole.log("useEffect")
    runValidation();
  }, []);

  // Limpa stream quando ele muda
  useEffect(() => {
    return () => {
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
    };
  }, [stream]);

  const resetValidation = () => {
    cleanupStream();
    setValidationResults({
      camera: null,
      lighting: null,
      network: null,
      device: null
    });
    setShowRetry(false);
    setShowAdvanceButton(false);
    setIsValidating(false);
    setCurrentStep('');
  };

  const runValidation = async () => {
    
    Mexx2DOConsole.log("runValidation")
    cleanupStream();
    setIsValidating(true);
    setShowRetry(false);
    setShowAdvanceButton(false);

    try {
      // 1. Valida integridade do dispositivo
      // setCurrentStep('Verificando integridade do dispositivo...');
      // const deviceResult = await validateDeviceIntegrity();
      // console.log('Device Result:', deviceResult); // Debug
      // console.log("entrei aqui")

      // 2. Valida câmera
      setCurrentStep('Analisando câmera e detectando anomalias...');
      const cameraResult = await validateCamera();
      console.log('Camera Result:', cameraResult); // Debug

      // Se câmera OK, valida iluminação
      let lightingResult = { success: false };
      if (cameraResult.success && cameraResult.stream) {
        const currentStream = cameraResult.stream;
        setStream(currentStream);

        if (videoRef.current && currentStream) {
          videoRef.current.srcObject = currentStream;
          try {
            await videoRef.current.play();
            await new Promise((resolve) => {
              videoRef.current.onloadedmetadata = resolve;
              setTimeout(resolve, 2000);
            });

            setCurrentStep('Analisando condições de iluminação...');
            lightingResult = await validateLighting(currentStream, videoRef, canvasRef);
            console.log('Lighting Result:', lightingResult); // Debug

            // Força falha se brilho muito baixo (câmera coberta)
            if (lightingResult.details?.brightness < 20) {
              lightingResult.success = false;
              lightingResult.details.condition = 'câmera coberta ou ambiente sem luz';
              console.log('⚠️ Câmera coberta detectada! Brilho:', lightingResult.details.brightness);
            }
          } catch (videoError) {
            console.error('Erro ao inicializar vídeo:', videoError);
            lightingResult = {
              success: false,
              error: 'Erro ao acessar câmera para validação de iluminação'
            };
          }
        }
      }

      // 3. Valida rede
      setCurrentStep('Testando conexão de rede...');
      const networkResult = await validateNetwork();
      console.log('Network Result:', networkResult); // Debug

      // Formata perda de pacotes separadamente para evitar erro de parsing
      const packetLossText = networkResult.details?.packetLoss !== undefined
        ? `${Number(networkResult.details.packetLoss).toFixed(1)}% (máx: 2%)`
        : 'N/A';

      // Formata resultados para exibição
      const formattedResults = {
        // device: {
        //   success: deviceResult.success,
        //   confidence: deviceResult.confidence || 0,
        //   details: {
        //     'Score de Segurança': `${deviceResult.securityScore || 0}% (mín: 50%)`,
        //     'DevTools Detectado': deviceResult.details?.devTools ? 'Sim ⚠️' : (isFirefox ? 'N/A (Firefox)' : 'Não ✓'),
        //     'WebDriver Detectado': deviceResult.details?.webDriver ? 'Sim ⚠️' : 'Não ✓',
        //     'Emulador Detectado': deviceResult.details?.emulator ? 'Sim ⚠️' : 'Não ✓',
        //     'Root/Jailbreak': (deviceResult.details?.rootJailbreak?.length > 0) ? 'Sim ⚠️' : 'Não ✓',
        //     'Proxy/VPN': deviceResult.details?.proxyVPN ? 'Detectado ⚠️' : 'Não detectado ✓',
        //     'Tempo de Execução': deviceResult.details?.executionTime || 'N/A'
        //   },
        //   error: deviceResult.error
        // },
        camera: {
          success: cameraResult.success,
          confidence: cameraResult.confidence || 0,
          details: {
            'Resolução': `${cameraResult.details?.resolution || 'N/A'} (mín: ${VALIDATION_PARAMS.camera.minWidth}x${VALIDATION_PARAMS.camera.minHeight})`,
            'Taxa de Quadros': cameraResult.details?.frameRate
              ? `${cameraResult.details.frameRate} FPS (mín: ${VALIDATION_PARAMS.camera.minFPS} FPS)`
              : 'N/A',
            'Score de Segurança': `${cameraResult.details?.securityScore || 100}% (mín: 60%)`,
            'Análise de Ruído': cameraResult.details?.noiseAnalysis?.isNatural === false
              ? 'Câmera Virtual Detectada ⚠️'
              : 'Câmera Física ✓',
            'Detecção de Loop': cameraResult.details?.loopDetection?.isLoop
              ? 'Loop Detectado ⚠️'
              : 'Vídeo ao Vivo ✓'
          },
          error: cameraResult.error
        },
        lighting: {
          success: lightingResult.success,
          confidence: lightingResult.confidence || 0,
          details: {
            'Brilho': `${lightingResult.details?.brightness || 0} (ideal: ${VALIDATION_PARAMS.lighting.minBrightness}-${VALIDATION_PARAMS.lighting.maxBrightness})`,
            'Condição': lightingResult.details?.condition || 'N/A',
            'Score de Qualidade': `${lightingResult.details?.quality?.score || 0}% (mín: 60%)`,
            'Uniformidade': lightingResult.details?.gradient?.uniformity
              ? `${Math.round(lightingResult.details.gradient.uniformity * 100)}% (mín: 70%)`
              : 'N/A',
            'Status': lightingResult.details?.condition === 'adequada'
              ? 'Iluminação OK ✓'
              : `Iluminação ${lightingResult.details?.condition || 'inadequada'} ⚠️`,
            'Problemas': lightingResult.details?.quality?.issues?.length > 0
              ? lightingResult.details.quality.issues.join(', ') + ' ⚠️'
              : 'Nenhum ✓'
          },
          error: lightingResult.error
        },
        network: {
          success: networkResult.success,
          confidence: networkResult.confidence || 0,
          details: {
            'Largura de Banda': networkResult.details?.bandwidth
              ? `${Math.round(networkResult.details.bandwidth)} kbps (mín: ${VALIDATION_PARAMS.network.minBandwidth} kbps)`
              : 'N/A',
            'Velocidade Upload': networkResult.details?.uploadSpeed
              ? `${Math.round(networkResult.details.uploadSpeed)} kbps`
              : 'N/A',
            'Latência': networkResult.details?.latency?.average
              ? `${Math.round(networkResult.details.latency.average)} ms (máx: 200ms)`
              : 'N/A',
            'Jitter': networkResult.details?.jitter
              ? `${Math.round(networkResult.details.jitter)} ms (máx: 30ms)`
              : 'N/A',
            'Perda de Pacotes': packetLossText,
            'Qualidade': `${networkResult.details?.quality?.grade || 'N/A'} (mín: D)`,
            'Conexão Estável': networkResult.details?.stability?.stable ? 'Sim ✓' : 'Não ⚠️'
          },
          error: networkResult.error
        }
      };

      setValidationResults(formattedResults);

      // Verifica se todas as validações passaram
      // const allPassed = deviceResult.success &&
      //   cameraResult.success &&
      //   lightingResult.success &&
      //   networkResult.success;

        const allPassed = 
        cameraResult.success &&
        lightingResult.success &&
        networkResult.success;

      console.log('=== RESULTADOS DAS VALIDAÇÕES ===');
      // console.log('Device:', deviceResult.success ? '✓' : '✗', 'Score:', deviceResult.securityScore);
      console.log('Camera:', cameraResult.success ? '✓' : '✗', 'Score:', cameraResult.details?.securityScore);
      console.log('Lighting:', lightingResult.success ? '✓' : '✗', 'Condição:', lightingResult.details?.condition);
      console.log('Network:', networkResult.success ? '✓' : '✗', 'Grade:', networkResult.details?.quality?.grade);
      console.log('Todas passaram?', allPassed);

      if (allPassed) {
        cleanupStream();
        setShowAdvanceButton(true);
      } else {
        setShowRetry(true);
        cleanupStream();
      }
    } catch (error) {
      console.error('Erro durante validação:', error);
      setShowRetry(true);
      cleanupStream();
    } finally {
      setIsValidating(false);
      setCurrentStep('');
    }
  };

  const handleRetry = () => {
    resetValidation();
    setTimeout(() => {
      runValidation();
    }, 100);
  };

  const handleAdvance = () => {
    // cleanupStream(); // Garante que a câmera seja desligada antes de prosseguir
    onSuccess(validationResults);
  };

  const hasResults = Object.values(validationResults).some(r => r !== null);

  // Ícone de seta para direita
  const ArrowRightIcon = () => (
    <svg viewBox="0 0 24 24" style={{ width: '20px', height: '20px', fill: '#fff' }}>
      <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
    </svg>
  );

  return (
    <div className="validation-card">
      {/* {!isValidating && !showRetry && !hasResults && (
        <div className="validation-intro">
          <BigCameraIcon />
          <h2>Preparar Validação do Dispositivo</h2>
          <p>
            Sistema avançado de validação que economiza custos verificando requisitos antes do AWS Rekognition.
          </p>
          <div className="alert alert-info">
            <strong>Validações de Segurança Enterprise:</strong><br />
            • <strong>Integridade:</strong> Score mínimo 50% (detecta root, emuladores, devtools)<br />
            • <strong>Câmera:</strong> Física, {VALIDATION_PARAMS.camera.minWidth}x{VALIDATION_PARAMS.camera.minHeight}px, {VALIDATION_PARAMS.camera.minFPS} FPS<br />
            • <strong>Iluminação:</strong> Brilho {VALIDATION_PARAMS.lighting.minBrightness}-{VALIDATION_PARAMS.lighting.maxBrightness}, natural<br />
            • <strong>Rede:</strong> Mínimo {VALIDATION_PARAMS.network.minBandwidth} kbps, latência menor que 200ms
          </div>
        
          <GVButton
            sx={{ marginTop: '20px' }}
            variant="contained"
            onClick={runValidation}
            style={{ padding: 14 }}
            label="Iniciar Validação Avançada" >
            Iniciar Validação Avançada
          </GVButton>
        </div>
      )} */}

      {isValidating && (
        <div className="loader">
          <div className="spinner" />
          <h3>{currentStep || 'Validando seu dispositivo...'}</h3>
          <div className="progress-bar">
            <div className="progress-fill" />
          </div>
          <p style={{ fontSize: '0.875rem', color: '#666', marginTop: '1rem' }}>
            Usando algoritmos de última geração para máxima segurança
          </p>
        </div>
      )}

      {!isValidating && hasResults && (
        <div className="validation-results">
          <h2>Resultados da Validação Avançada</h2>

          <ValidationResult
            title="Integridade do Dispositivo"
            result={validationResults.device}
            type="device"
          />
          <ValidationResult
            title="Câmera"
            result={validationResults.camera}
            type="camera"
          />
          <ValidationResult
            title="Iluminação"
            result={validationResults.lighting}
            type="lighting"
          />
          <ValidationResult
            title="Conexão de Rede"
            result={validationResults.network}
            type="network"
          />

          {showAdvanceButton && (
            <div className="success-section">
              <div className="alert alert-success">
                <strong>✅ Validação Concluída com Sucesso!</strong><br />
                Todos os requisitos foram atendidos com alta confiança.
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <GVButton
                  sx={{ marginTop: '20px' }}
                  variant="contained"
                  onClick={handleAdvance}
                  style={{ padding: 14 }}
                  label="Prosseguir para verificação de vida" >
                  Prosseguir para verificação de vida
                </GVButton>
              </div>
            </div>
          )}

          {showRetry && (
            <div className="retry-section">
              <div className="alert alert-error">
                <strong>⚠️ Validação Incompleta</strong><br />
                Alguns requisitos não foram atendidos. Verifique os itens marcados com ⚠️ acima.

                {/* Mensagens específicas para problemas comuns */}
                {validationResults.device?.details?.['DevTools Detectado']?.includes('Sim') && (
                  <div style={{ marginTop: '0.5rem', fontWeight: 'bold', color: '#c62828' }}>
                    🛠️ DevTools detectado! Por favor, feche as ferramentas de desenvolvedor (F12) e tente novamente.
                  </div>
                )}
                {validationResults.lighting?.details?.condition?.includes('coberta') && (
                  <div style={{ marginTop: '0.5rem', fontWeight: 'bold' }}>
                    🚫 Câmera coberta detectada! Remova qualquer obstrução.
                  </div>
                )}
                {validationResults.lighting?.details?.condition?.includes('escura') && (
                  <div style={{ marginTop: '0.5rem', fontWeight: 'bold' }}>
                    💡 Ambiente muito escuro! Melhore a iluminação.
                  </div>
                )}
                {validationResults.camera?.details?.['Análise de Ruído']?.includes('Virtual') && (
                  <div style={{ marginTop: '0.5rem', fontWeight: 'bold' }}>
                    📹 Câmera virtual detectada! Use uma câmera física.
                  </div>
                )}
              </div>
              {/* <button className="button button-primary" onClick={handleRetry}>
                <RefreshIcon />
                Repetir Validação
              </button> */}

              <GVButton
                sx={{ marginTop: '20px' }}
                variant="contained"
                onClick={handleRetry}
                style={{ padding: 14 }}
                label="Repetir Validação" >
                 Repetir Validação
              </GVButton>
            </div>
          )}
        </div>
      )}

      {/* Preview da Câmera */}
      <div style={{ display: 'none' }}>
        <video ref={videoRef} autoPlay muted playsInline />
        <canvas ref={canvasRef} />
      </div>
    </div>
  );
};

export default ValidationStep;